import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { IconSizeEnum, IWarrantyInformations, SdHtmlComponent, SdIconComponent, SdTitleComponent } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-warranty-informations',
  templateUrl: './warranty-informations.component.html',
  styleUrls: ['./warranty-informations.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdTitleComponent,
    SdIconComponent,
    SdHtmlComponent
  ]
})
export class SdWarrantyInformationsComponent {
  @Input()
  data: IWarrantyInformations;

  IconSizeEnum = IconSizeEnum;
}
